import type { IconSvgObject } from './types';

const MouseLeftClick04Icon: IconSvgObject = [
  ["path", { d: "M13.5 6V2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 6H13C12.4477 6 12 6.44772 12 7V9.5C12 10.0523 12.4477 10.5 13 10.5H14C14.5523 10.5 15 10.0523 15 9.5V7C15 6.44772 14.5523 6 14 6Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M5 2C3.94531 3.13158 3.23544 4.50113 3 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M13.5 22C19.5 22 21 17.49 21 12C21 6.50998 19.5 2 13.5 2C7.49993 2 6 6.50996 6 12C6 17.49 7.49993 22 13.5 22Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default MouseLeftClick04Icon;
